module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ashou18-07b1d4238061af8c639b0e276bd53d67.jpg";